/**
 * Normalizes the items to group them by category.
 * @param {Array} items - The items to normalize.
 * @returns {Array} The normalized items, grouped by category.
 */
export const normalizeTypeaheadItems = (items) => {
  if (!Array.isArray(items) || items.length === 0) {
    return [];
  }

  const categoriesMap = items.reduce((acc, item) => {
    const categoryLabel = item.category || '';
    if (!acc[categoryLabel]) {
      acc[categoryLabel] = {
        category: categoryLabel,
        items: [],
      };
    }
    acc[categoryLabel].items.push({
      value: item.value,
      label: item.label,
      category: item.category,
    });
    return acc;
  }, {});

  const sortedCategories = sortCategories(Object.values(categoriesMap));
  const sortedCategoriesWithSortedItems =
    sortItemsInCategories(sortedCategories);

  return sortedCategoriesWithSortedItems;
};

/**
 * @param {Array} items - The items to filter.
 * @param {string} query - The query string / search.
 * @param {boolean} shouldSearchCategories - If the search should include the categories or not
 * @returns {Array} The filtered items.
 */
export const filterTypeaheadItems = (items, query, shouldSearchCategories) => {
  const lowerCaseQuery = query.toLowerCase();

  if (items.length === 0) {
    return [];
  }

  return items.reduce((acc, category) => {
    const categoryLabel = category.category || '';
    const categoryMatches = categoryLabel
      .toLowerCase()
      .includes(lowerCaseQuery);

    if (shouldSearchCategories && categoryMatches) {
      acc.push(category);
    } else {
      const filteredItems = category.items.filter((item) =>
        item.label.toLowerCase().includes(lowerCaseQuery)
      );

      if (filteredItems.length > 0) {
        acc.push({
          category: category.category,
          items: filteredItems,
        });
      }
    }

    return acc;
  }, []);
};

const sortCategories = (categories) => {
  return categories.sort((a, b) => {
    const isCategoryAEmpty = a.category === '' ? 1 : 0;
    const isCategoryBEmpty = b.category === '' ? 1 : 0;

    if (isCategoryAEmpty !== isCategoryBEmpty) {
      return isCategoryAEmpty - isCategoryBEmpty;
    }

    return a.category.localeCompare(b.category);
  });
};

const sortItemsInCategories = (categories) => {
  return categories.map((category) => ({
    ...category,
    items: [...category.items].sort((itemA, itemB) =>
      itemA.label.localeCompare(itemB.label)
    ),
  }));
};
